// Entry point for the build script in your package.json
import "./config/request_submit_polyfill"
import "@hotwired/turbo-rails"
import debounced from "debounced"
import "./controllers"
import "./config/turbo_confirm"

debounced.initialize()
